let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3azdD")).then(() => parcelRequire('14BXk'));